import styled from '@emotion/styled';
import { spacing } from '@naf/theme';

export const Wrapper = styled.div`
  margin-top: ${spacing.space16};
  margin-bottom: ${spacing.space80};

  p {
    margin: 0 0 ${spacing.space8} !important;
  }
`;

export const AdditionalInfo = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${spacing.space24};
`;

export const CountryWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: ${spacing.space24};
  padding-bottom: ${spacing.space24};
  border-bottom: 1px solid #e0e0e0;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: ${spacing.space40};

  h5,
  p {
    margin: 0;
  }
`;

export const CloseButton = styled.button`
  /* reset style */
  border: none;
  margin: 0;
  width: auto;
  overflow: visible;
  background: transparent;
  color: inherit;
  font: inherit;
  line-height: normal;
  touch-action: manipulation;
  appearance: none !important;

  /* style */
  display: flex;
  align-items: flex-start;
  cursor: pointer;
  margin-top: -7px;
  padding: ${spacing.space12};
  height: fit-content;
`;
